import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

// (임시 CSS - LoginPage와 유사한 스타일)
const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    fontFamily: 'Arial, sans-serif'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
    width: '300px'
  },
  input: {
    marginBottom: '10px',
    padding: '8px',
    fontSize: '16px'
  },
  button: {
    padding: '10px',
    fontSize: '16px',
    backgroundColor: '#28a745', // 녹색
    color: 'white',
    border: 'none',
    cursor: 'pointer'
  },
  message: {
    marginTop: '15px',
    textAlign: 'center'
  },
  error: {
    color: 'red'
  },
  success: {
    color: 'green'
  },
  info: {
    fontSize: '13px',
    color: '#666',
    marginBottom: '10px',
    padding: '8px',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    lineHeight: '1.5'
  }
};

const RegisterPage = () => {
  const [userId, setUserId] = useState('');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [registrationCode, setRegistrationCode] = useState('');
  
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirmPassword) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    try {
      // [POST] /api/auth/register (백엔드 1단계에서 만듦)
      const res = await api.post('/auth/register', {
        userId,
        name,
        password,
        registrationCode
      });

      // 가입 성공
      setMessage(`${res.data.message} 잠시 후 로그인 페이지로 이동합니다.`);
      setTimeout(() => {
        navigate('/login');
      }, 3000);

    } catch (err) {
      // 409 (아이디 중복) 등
      setError(err.response?.data?.message || '가입 중 오류가 발생했습니다.');
    }
  };

  return (
    <div style={styles.container}>
      <h2>회원 가입</h2>
      <form style={styles.form} onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="아이디"
          style={styles.input}
          value={userId}
          onChange={(e) => setUserId(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="성명"
          style={styles.input}
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="비밀번호"
          style={styles.input}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="비밀번호 확인"
          style={styles.input}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <div style={styles.info}>
          시스템 <strong>최초 1명</strong>은 가입 코드 <strong>senior</strong>로 관리자로 등록되며 바로 로그인할 수 있습니다.
          그다음부터는 가입 코드가 맞아도 <strong>승인대기</strong>로 접수되며, 관리자가 일반사용자 또는 관리자로 등급을 변경한 뒤에만 로그인할 수 있습니다.
        </div>
        <input
          type="text"
          placeholder="가입 코드"
          style={styles.input}
          value={registrationCode}
          onChange={(e) => setRegistrationCode(e.target.value)}
        />
        <button type="submit" style={styles.button}>가입하기</button>
        
        {error && <div style={{...styles.message, ...styles.error}}>{error}</div>}
        {message && <div style={{...styles.message, ...styles.success}}>{message}</div>}
      </form>
      <div style={styles.message}>
        <Link to="/login">이미 계정이 있으신가요? 로그인</Link>
      </div>
    </div>
  );
};

export default RegisterPage;